import { BaseCellElement } from './baseCellElement';
import { UIElement } from '../uiElements';
import { IBaseUIElementOptions } from '../../../interfaces/options';
import { CellElementType } from '../../../enums';

export class ValidationCellElement extends BaseCellElement {
	private base: UIElement<any>;
	constructor(
		base: UIElement<any>,
		editable: KnockoutObservable<boolean>,
		options: IBaseUIElementOptions
	) {
		super(options.size, CellElementType.VALIDATION, editable, options.template);
		this.base = base;
	}
}
